import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "\uD55C\uAD6D\uC5B4",
  code: "ko",
  messages: {
    alert: {
      close: "\uB2EB\uAE30"
    },
    authForm: {
      hidePassword: "\uBE44\uBC00\uBC88\uD638 \uC228\uAE30\uAE30",
      showPassword: "\uBE44\uBC00\uBC88\uD638 \uD45C\uC2DC",
      submit: "\uACC4\uC18D"
    },
    banner: {
      close: "\uB2EB\uAE30"
    },
    calendar: {
      nextMonth: "\uB2E4\uC74C \uB2EC",
      nextYear: "\uB2E4\uC74C \uD574",
      prevMonth: "\uC774\uC804 \uB2EC",
      prevYear: "\uC774\uC804 \uD574"
    },
    carousel: {
      dots: "\uD45C\uC2DC\uD560 \uC2AC\uB77C\uC774\uB4DC \uC120\uD0DD",
      goto: "{slide} \uD398\uC774\uC9C0\uB85C \uC774\uB3D9",
      next: "\uB2E4\uC74C",
      prev: "\uC774\uC804"
    },
    chatPrompt: {
      placeholder: "\uC5EC\uAE30\uC5D0 \uBA54\uC2DC\uC9C0\uB97C \uC785\uB825\uD558\uC138\uC694..."
    },
    chatPromptSubmit: {
      label: "\uC804\uC1A1"
    },
    colorMode: {
      dark: "\uB2E4\uD06C",
      light: "\uB77C\uC774\uD2B8",
      switchToDark: "\uB2E4\uD06C \uBAA8\uB4DC\uB85C \uC804\uD658",
      switchToLight: "\uB77C\uC774\uD2B8 \uBAA8\uB4DC\uB85C \uC804\uD658",
      system: "\uC2DC\uC2A4\uD15C"
    },
    commandPalette: {
      back: "\uB4A4\uB85C",
      close: "\uB2EB\uAE30",
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      noMatch: "\uC77C\uCE58\uD558\uB294 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      placeholder: "\uBA85\uB839\uC744 \uC785\uB825\uD558\uAC70\uB098 \uAC80\uC0C9..."
    },
    contentSearch: {
      links: "\uB9C1\uD06C",
      theme: "\uD14C\uB9C8"
    },
    contentSearchButton: {
      label: "\uAC80\uC0C9..."
    },
    contentToc: {
      title: "\uC774 \uD398\uC774\uC9C0\uC5D0\uC11C"
    },
    dashboardSearch: {
      theme: "\uD14C\uB9C8"
    },
    dashboardSearchButton: {
      label: "\uAC80\uC0C9..."
    },
    dashboardSidebarCollapse: {
      collapse: "\uC0AC\uC774\uB4DC\uBC14 \uCD95\uC18C",
      expand: "\uC0AC\uC774\uB4DC\uBC14 \uD655\uC7A5"
    },
    dashboardSidebarToggle: {
      close: "\uC0AC\uC774\uB4DC\uBC14 \uB2EB\uAE30",
      open: "\uC0AC\uC774\uB4DC\uBC14 \uC5F4\uAE30"
    },
    error: {
      clear: "\uD648\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30"
    },
    fileUpload: {
      removeFile: "{filename} \uC81C\uAC70"
    },
    header: {
      close: "\uBA54\uB274 \uB2EB\uAE30",
      open: "\uBA54\uB274 \uC5F4\uAE30"
    },
    inputMenu: {
      create: '"{label}" \uC0DD\uC131',
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      noMatch: "\uC77C\uCE58\uD558\uB294 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
    },
    inputNumber: {
      decrement: "\uAC10\uC18C",
      increment: "\uC99D\uAC00"
    },
    modal: {
      close: "\uB2EB\uAE30"
    },
    pricingTable: {
      caption: "\uAC00\uACA9 \uD50C\uB79C \uBE44\uAD50"
    },
    prose: {
      codeCollapse: {
        closeText: "\uC811\uAE30",
        name: "\uCF54\uB4DC",
        openText: "\uD3BC\uCE58\uAE30"
      },
      collapsible: {
        closeText: "\uC228\uAE30\uAE30",
        name: "\uC18D\uC131",
        openText: "\uBCF4\uAE30"
      },
      pre: {
        copy: "\uCF54\uB4DC\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC"
      }
    },
    selectMenu: {
      create: '"{label}" \uC0DD\uC131',
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      noMatch: "\uC77C\uCE58\uD558\uB294 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.",
      search: "\uAC80\uC0C9..."
    },
    slideover: {
      close: "\uB2EB\uAE30"
    },
    table: {
      noData: "\uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
    },
    toast: {
      close: "\uB2EB\uAE30"
    }
  }
});
